import { useObjectTypeId } from 'crm-object-board-core/objectTypeDefinition';
import { CONTACT_TYPE_ID, COMPANY_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';

// todo update FAS to include hasSinglePipeline so both FE/BE can use it
// for these cases we always send undefined as pipelineId
// we always read/save card settings by object type
const OBJECT_TYPES_WITH_ONE_PIPELINE = new Set([CONTACT_TYPE_ID, COMPANY_TYPE_ID]);
export const useHasSinglePipeline = () => {
  const objectTypeId = useObjectTypeId();
  return OBJECT_TYPES_WITH_ONE_PIPELINE.has(objectTypeId);
};